import React, { Children } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import classNames from "classnames";

export const HungerTabSet: React.FC<{
  tabs: Array<string>;
  sticky?: boolean;
  mode?: "gather" | "separate";
}> = ({ tabs, sticky, children, mode }) => {
  return (
    <Tabs
      className={classNames("react-tabs", {
        "flex flex-col items-stretch max-h-full": sticky,
        "bg-white rounded-xl": mode === "gather",
      })}
    >
      <TabList
        className={classNames(
          "flex lg:justify-center lg:flex-wrap",
          "bg-white rounded-lg",
          "overflow-scroll",
          {
            "flex-shrink-0": sticky,
            "border-b border-solid border-gray-4 rounded-b-none":
              mode === "gather",
          }
        )}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab}
            className={classNames(
              "py-5 px-4 md:py-4",
              "md:w-[7.5rem] md:mx-[1.875rem]",
              "text-center",
              "flex-shrink-0",
              "hover:cursor-pointer"
            )}
            selectedClassName={"text-primary-pink font-semibold"}
          >
            {tab}
          </Tab>
        ))}
      </TabList>
      {Children.map(children, (child, index) => (
        <TabPanel
          key={index}
          className={classNames({
            "flex-1 overflow-scroll": sticky,
          })}
          selectedClassName={"py-6"}
        >
          {child}
        </TabPanel>
      ))}
    </Tabs>
  );
};
